import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
    useState,
} from 'react';

import {
    useTimeout,
} from 'tools/hooks';

import {
    BaseButton,
} from 'components/buttons';

import {
    COPIED_TIMEOUT_MS,
} from './constants';

import copyImage from './media/copy.svg';

import styles from './DetailField.module.scss';

const DetailField: FC<IProps> = (props) => {
    const [isCopied, setIsCopied] = useState(false);

    const {keepTimeout} = useTimeout(COPIED_TIMEOUT_MS, () => {
        setIsCopied(false);
    });

    const onCopy = () => {
        navigator.clipboard.writeText(props.detailField.value);
        setIsCopied(true);
        keepTimeout();
    };

    return (
        <div className={classNames(styles.detailField, props.className)}>
            <div className={styles.content}>
                <div className={styles.label}>
                    {props.detailField.name}
                </div>
                <div className={styles.value}>
                    {props.detailField.value}
                </div>
            </div>
            <BaseButton
                className={styles.copyButton}
                text={isCopied ? 'Copied' : 'Copy'}
                iconLeft={
                    <img
                        className={styles.copyImage}
                        src={copyImage}
                        alt={'Copy'}
                    />
                }
                onClick={onCopy}
            />
        </div>
    );
};

export default DetailField;
